import Nav from "./Nav.js";

export default class NavConf {
  constructor(page, conf) {
    this.page = page;
    this.nav = conf.nav;
    this.btn = conf.btn;
    this.btnLabel = conf.btnLabel;
    this.btnLabelEl = conf.btnLabelEl;
    this.clickout = conf.clickout;
    this.flyout = conf.flyout;
    this.aside = conf.aside;
    this.btnsOpenSubs = conf.btnsOpenSubs;
    this.voices = conf.voices;
    this.subMenus = conf.subMenus;
    this.languageLabel = conf.languageLabel;
    this.languageLabelEl = conf.languageLabelEl;
    this.isMob = window.matchMedia("(max-width: 767px)")?.matches
      ? true
      : false;    
  }

  init() {
    let resizing;
    window.addEventListener("resize", (e) => {
      clearTimeout(resizing);
      resizing = setTimeout(() => {
        this.isMob = window.matchMedia("(max-width: 767px)")?.matches
          ? true
          : false;
      }, 250);
    });

    this.setNavProps();
    this.initNavProperties();
    this.initNav();       
  }

  initNav() {
    // toggle navigation
    this.toggleNav();

    // toggle sub-menu navigation
    this.handleBtnActivation();
    this.handleVoiceHover();
    this.handleFlyoutHover();

    // close nav on clickout click
    this.initClickout();

    // init btns-back sub-menu mobile
    this.flyout?.querySelectorAll(".js-btn-close-sub-menu")?.forEach((btn) => {
      btn.addEventListener("click", (e) => {
        this.flyout?.querySelector(".is-open")?.classList.remove("is-open");
        this.flyout?.querySelector(".has-sub-menu.is-active")?.classList.remove("is-active");
      });
    });
  }

  handleVoiceHover() {
    const handleVoiceHover = (e, i, voice) => {     
      const openedSibling = Nav.Flyout?.querySelector(".sub-menu.is-open");
      const btnOpenedSibling =
        Array.from(Nav.BtnsOpenSubs)
          .find(btn => btn.dataset.subMenu === openedSibling?.dataset.subMenu);

      btnOpenedSibling?.classList.remove("is-active");
      openedSibling?.classList.remove("is-open");
    }

    Nav.Voices?.forEach((voice, i) => voice.addEventListener("mouseover", (e) => {      
        handleVoiceHover(e, i, voice);
    }));
  }

  handleFlyoutHover() {
    this.flyout?.addEventListener("mouseleave", (e) => {
      Nav.closeNav(this.isMob);
    });
  }

  handleBtnActivation() {
    const animationTiming = 625;
    let timing;
    const handleBtnActivation = (e, i, btn) => {      
      e.preventDefault();
      clearTimeout(timing);

      const subMenu = Array.from(Nav.SubMenus)?.find(menu => menu.dataset.subMenu === i);
      const openedSibling = Nav.Flyout?.querySelector(".sub-menu.is-open");
      const btnOpenedSibling =
        Array.from(Nav.BtnsOpenSubs)
          .find(btn => btn.dataset.subMenu === openedSibling?.dataset.subMenu);

      Nav.Flyout?.querySelector(".voice.is-active")?.classList.remove("is-active");
      btn.classList.add("is-active");

      if (
        openedSibling
        && openedSibling !== subMenu
      ) {
        btnOpenedSibling?.classList.remove("is-active");
        openedSibling?.classList.remove("is-open");
        timing = setTimeout(() => subMenu.classList.add("is-open"), animationTiming);

      } else {
        !subMenu.classList.contains("is-open")
          && subMenu.classList.add("is-open");
      }
    }

    Nav.BtnsOpenSubs?.forEach((btn) => {
      const i = btn.dataset?.subMenu;
      btn.addEventListener("click", (e) => handleBtnActivation(e, i, btn));
      btn.addEventListener("mouseover", (e) => {                
        handleBtnActivation(e, i, btn);
      });
    });
  }

  toggleNav() {
    Nav.Btn?.addEventListener("click", (e) => {
      Nav.isOpen
        ? Nav.closeNav()
        : Nav.openNav();
    });
  }

  initClickout() {
    Nav.Clickout?.addEventListener("click", () => Nav.closeNav());
  }

  setNavProps() {
    Nav.nav = this.nav;
    Nav.btn = this.btn;
    Nav.btnLabel = this.btnLabel;
    Nav.btnLabelEl = this.btnLabelEl;
    Nav.clickout = this.clickout;
    Nav.flyout = this.flyout;
    Nav.aside = this.aside;
    Nav.btnsOpenSubs = this.btnsOpenSubs;
    Nav.voices = this.voices;
    Nav.subMenus = this.subMenus;
    Nav.languageLabel = this.languageLabel;
    Nav.languageLabelEl = this.languageLabelEl;
  }

  initNavProperties() {
    let navHeight = Nav.navHeight;
    let flyoutWidth = Nav.flyoutWidth;
    let asideHeight = Nav.asideHeight;

    this._navHeightProp = navHeight;
    this._flyoutWidthProp = flyoutWidth;
    this._asideHeightProp = asideHeight;

    let resizing;

    window.addEventListener("resize", (e) => {
      clearTimeout(resizing);
      resizing = setTimeout(() => {
        navHeight = Nav.navHeight;
        flyoutWidth = Nav.flyoutWidth;
        this._navHeightProp = navHeight;
        this._flyoutWidthProp = flyoutWidth;
        this._asideHeightProp = asideHeight;
      }, 250);
    });
  }

  set _navHeightProp(navHeight) {    
    this.page?.style.setProperty("--nav-h", `${navHeight}px`);
  }

  set _flyoutWidthProp(flyoutWidth) {
    this.page?.style.setProperty("--flyout-w", `${flyoutWidth}px`);
  }

  set _asideHeightProp(asideHeight) {
    this.page?.style.setProperty("--aside-h", `${asideHeight}px`);
  }
}